import 'app/zod';

import { createRoot } from 'react-dom/client';
import 'react-perfect-scrollbar/dist/css/styles.css';

import App from 'app/App';
import * as serviceWorker from 'app/serviceWorker';
import 'app/styles/style.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Container not found');
}

const root = createRoot(container);

root.render(<App />);

serviceWorker.unregister();
